import React, { useState } from 'react';
import {withTranslation} from 'react-i18next';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import Cart from "./Cart";
import './open-card-block.scss';
import FormattedPrice from "../../components/FormattedPrice";

const OpenCartBlock = ({totalAmount, totalQuantity, t}) => {
  const [cartIsOpened, setCartIsOpened] = useState(false);

  const toggleCartPopup = () => {
    setCartIsOpened(!cartIsOpened);
  };

  return (
    <>
      <div onClick={toggleCartPopup} className={"open-cart-btn"}>
        <div className={"cart-icon"}>
          <FontAwesomeIcon icon="cart-plus" />
          <div className={"items-quantity"}>{totalQuantity}</div>
        </div>
        <div className={"order-label"}>{t('open-cart-btn.order-label')}</div>
        <div className={"price-block"}>
          <FormattedPrice price={totalAmount} />
        </div>
      </div>
      <div className={`mobile-cart-popup ${cartIsOpened ? "opened" : ""}`}>
        <div className={"hide-btn"} onClick={toggleCartPopup}>
          <FontAwesomeIcon icon="chevron-down" />
        </div>
        <div className={"popup-content"}>
          <Cart />
        </div>
      </div>
    </>
  );
};

export default withTranslation()(OpenCartBlock);
